import { render, staticRenderFns } from "./DepositDetailModal.vue?vue&type=template&id=7bbbbf6e&"
import script from "./DepositDetailModal.vue?vue&type=script&lang=js&"
export * from "./DepositDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports